module.exports = __webpack_public_path__ + "static/img/img_4.0a9f471a.jpg";